module.exports = __webpack_public_path__ + "assets/mastdiagram.1b6607c5.svg";